export default "__VITE_ASSET__C7r1x2OP__"